export default __webpack_public_path__ + "static/media/powerClosed.e30e1d47.jpg";